import React = require("react");
import ToolbarItemContainer from "./ToolbarItemContainer";
import Mutex from "orbiter-core/src/Mutex";

export interface IToolbarContextValue {
    toolbarItems: JSX.Element[];
    addToolbarItem(toolbarItem: JSX.Element): Promise<void>;
    removeToolbarItem(toolbarItem: ToolbarItemContainer): Promise<void>;
    removeToolbarItems(toolbarItems: ToolbarItemContainer[]): Promise<void>;
}

export const ToolbarContext = React.createContext<IToolbarContextValue>({
    toolbarItems: [],
    addToolbarItem: (toolbarItem: JSX.Element) => {console.error("Used context before defined (add)."); return Promise.resolve()},
    removeToolbarItem: (toolbarItem: ToolbarItemContainer) => {console.error("Used context before defined (remove)."); return Promise.resolve()},
    removeToolbarItems: (toolbarItem: ToolbarItemContainer[]) => {console.error("Used context before defined (remove)."); return Promise.resolve()},
});

export class ToolbarMgr extends React.Component<{onMount:((context) => void)}>{
    static contextType = ToolbarContext;
    public componentWillMount(){
        this.props.onMount(this.context);
    }

    render(){return null}
}

export default class ToolbarContextProvider extends React.Component<any, {toolbarItems: ToolbarItemContainer[]}>{

    constructor(_){
        super(_);
        this.state={toolbarItems:[]};
    }

    private toolbarMutex = new Mutex();

    async addToolbarItem(toolbarItem: JSX.Element): Promise<ToolbarItemContainer>{
        const toolbarItemContainer = new ToolbarItemContainer(toolbarItem);
        await this.toolbarMutex.runCriticalSection(async ()=>{
            await new Promise((resolve) => {
                let toolbarItems: ToolbarItemContainer[] =  [...this.state.toolbarItems];
                toolbarItems.push(toolbarItemContainer);
                this.setState({toolbarItems}, () => resolve());
            })
        })
        return toolbarItemContainer;
    }

    async removeToolbarItem(toolbarItem: ToolbarItemContainer): Promise<void>{
        await this.toolbarMutex.runCriticalSection(async ()=>{
            await new Promise((resolve) => {
                const prev = [...this.state.toolbarItems];
                let toolbarItems: ToolbarItemContainer[] =  [...this.state.toolbarItems];
                toolbarItems = toolbarItems.filter(ti => {
                    return ti !== toolbarItem;
                });
                this.setState({toolbarItems}, () => resolve());
            })
        })
    }

    async removeToolbarItems(toolbarItems: ToolbarItemContainer[]): Promise<void>{
        await toolbarItems.forEach(async (tbi: ToolbarItemContainer) => {
            await this.removeToolbarItem(tbi)});
    }

    render(){
        return <ToolbarContext.Provider 
            value={{
                toolbarItems: this.state.toolbarItems.map(ti=>ti.getToolbarItem()),
                addToolbarItem: this.addToolbarItem.bind(this),
                removeToolbarItem: this.removeToolbarItem.bind(this),
                removeToolbarItems: this.removeToolbarItems.bind(this),
            }}
        >
            {this.props.children}
        </ToolbarContext.Provider>
    }

}